import React, { useEffect, useState } from "react";
import apiClient from "../api/apiClient";
import Select from "react-select";

// Page component for pending routing
const RuteoPendiente = ({ initialProject, initialEntDate, initialStartRoute, company }) => {
  const [groups, setGroups] = useState([]); // [{ key: 'InstitutionName', code: 'CntctCode', items: [...], order: 0 }]
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState(null);
  const [entDate, setEntDate] = useState("");
  const [rutaIni, setRutaIni] = useState("");

  // Load projects once
  useEffect(() => {
    const loadProjects = async () => {
      try {
        const resp = await apiClient.get("/sales-orders/projects");
        const data = Array.isArray(resp.data) ? resp.data : [];
        setProjects(data.map((p) => ({ value: p.PrjCode, label: `${p.PrjName}` })));
      } catch (err) {
        console.error("Error loading projects", err);
      }
    };
    loadProjects();
  }, []);


  const fetchData = async (opts = {}) => {
    setLoading(true);
    setError("");
    try {
      // Determine params: prefer opts, then component state, then props
      const sapUser = JSON.parse(localStorage.getItem("sapUser"));
      const companyDB = company || sapUser?.CompanyDB || "";
  const projectParam = opts.project?.value ?? project?.value ?? "";
  const FechaEntParam = opts.FechaEnt ?? entDate ?? initialEntDate ?? "";
  const RutaIniParam = opts.RutaIni ?? rutaIni ?? initialStartRoute ?? "";

      const params = {
        project: projectParam,
        FechaEnt: FechaEntParam,
        RutaIni: RutaIniParam,
        company: companyDB,
      };
      const resp = await apiClient.get("/logistica/ruteo-pendiente", { params });
      const data = Array.isArray(resp.data) ? resp.data : [];

      // Group by institution. Prefer T8.Name then T1.CntctCode
      const map = new Map();
      data.forEach((row) => {
        const key = row.Institucion || row.Name || row.CntctCode || row.CntctCode_ || "Sin Institucion";
        const code = row.CntctCode || row.CntctCode_ || null;
        if (!map.has(key)) map.set(key, { key, code, items: [] });
        map.get(key).items.push({ DocEntry: row.DocEntry, DocNum: row.DocNum, U_Serv: row.U_Serv || row.U_Serv_ || row.U_Servica || "" });
      });

      const arr = Array.from(map.values()).map((g, idx) => ({ ...g, order: idx + 1 }));
      setGroups(arr);
    } catch (err) {
      console.error("Error fetching ruteo pendiente", err);
      setError("Error al obtener ruteos pendientes.");
    } finally {
      setLoading(false);
    }
  };

  const handleObtener = () => {
    // Only fetch when user requests
    fetchData({ project, FechaEnt: entDate, RutaIni: rutaIni });
  };

  const moveUp = (index) => {
    if (index <= 0) return;
    const a = [...groups];
    const tmp = a[index - 1];
    a[index - 1] = a[index];
    a[index] = tmp;
    // reindex orders
    setGroups(a.map((g, i) => ({ ...g, order: i + 1 })));
  };
  const moveDown = (index) => {
    if (index >= groups.length - 1) return;
    const a = [...groups];
    const tmp = a[index + 1];
    a[index + 1] = a[index];
    a[index] = tmp;
    setGroups(a.map((g, i) => ({ ...g, order: i + 1 })));
  };

  const handleGenerarRuteo = async () => {
    setSaving(true);
    setError("");
    try {
      // Build details: one row per delivery (DocEntry) with the order assigned to its institution
      const details = [];
      groups.forEach((g) => {
        g.items.forEach((it) => {
          details.push({ U_DocEntry: it.DocEntry, U_Orden: g.order, U_Estado: "PE" });
        });
      });

      const payload = {
        U_Project: project?.value ?? initialProject?.value ?? "",
        U_FechaEnt: entDate ?? initialEntDate ?? "",
        U_RutaIni: rutaIni ?? initialStartRoute ?? "",
        //CompanyDB: companyDB,
        RUTEO_DETCollection: details, // detail array for service layer / UDO
      };
        //console.log("Payload to send for ruteo generation:", payload);
        //POST to backend endpoint that will call Service Layer; user specified POST ruteo-pendiente
        const res = await apiClient.post("/ruteo-pendiente", payload);
      if (res && (res.status === 200 || res.status === 201)) {
        alert("Ruteo generado correctamente.");
      } else {
        alert("Respuesta inesperada al generar ruteo.");
      }
    } catch (err) {
      console.error("Error generando ruteo", err);
      setError("Error al generar ruteo. Revisa consola para más detalles.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Ruteo Pendiente</h4>
        <div>
          <button className="btn btn-sm btn-primary" onClick={handleGenerarRuteo} disabled={saving} style={{ marginLeft: 8 }}>
            {saving ? "Generando..." : "Generar Ruteo"}
          </button>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="mb-3">
          <div className="row g-2">
            <div className="col-md-5">
              <label>Proyecto:</label>
              <Select options={projects} value={project} onChange={setProject} placeholder="Seleccione un proyecto..." isSearchable />
            </div>
            <div className="col-md-3">
              <label>Fecha de Entrega:</label>
              <input type="date" className="form-control" value={entDate} onChange={(e) => setEntDate(e.target.value)} />
            </div>
            <div className="col-md-2">
              <label>Ruta:</label>
              <input type="number" className="form-control" value={rutaIni} onChange={(e) => setRutaIni(e.target.value)} />
            </div>
            <div className="col-md-2 d-flex align-items-end">
              <button className="btn btn-success w-100" onClick={handleObtener} disabled={loading}>
                {loading ? "Cargando..." : "Obtener Ruteo"}
              </button>
            </div>
          </div>
        </div>

      {loading ? (
        <div>Cargando...</div>
      ) : (
        <div>
          <p>Instituciones: {groups.length}</p>
          <div>
            {groups.map((g, idx) => (
              <div key={g.key + idx} style={styles.groupCard}>
                <div style={styles.groupHeader}>
                  <div>
                    <strong>{g.order}.</strong>&nbsp;
                    <strong>{g.key}</strong>
                    {g.code ? <small style={{ marginLeft: 8 }}>({g.code})</small> : null}
                  </div>
                  <div>
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => moveUp(idx)} disabled={idx === 0} style={{ marginRight: 6 }}>
                      ↑
                    </button>
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => moveDown(idx)} disabled={idx === groups.length - 1}>
                      ↓
                    </button>
                  </div>
                </div>

                <div style={styles.itemsList}>
                  {g.items.map((it) => (
                    <div key={it.DocEntry} style={styles.itemRow}>
                      <div>ID Interno: {it.DocEntry}</div>
                      <div>Nro Documento: {it.DocNum}</div>
                      <div>Servicios: {it.U_Serv}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },
  modal: {
    background: "#fff",
    width: "80%",
    maxHeight: "80%",
    overflow: "auto",
    borderRadius: 6,
    padding: 16,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  groupCard: {
    border: "1px solid #ddd",
    borderRadius: 6,
    marginBottom: 8,
    padding: 8,
  },
  groupHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  itemsList: {
    paddingLeft: 8,
  },
  itemRow: {
    display: "flex",
    gap: 12,
    padding: "6px 0",
    borderBottom: "1px dashed #eee",
  },
};

export default RuteoPendiente;
